<!-- <mini-profiler></mini-profiler> -->
<loading-overlay></loading-overlay>
<modal></modal>
@if (isReady) {
  <menu-header [ngClass]="{'precious': !isTitanium && (appState.showPreciousTheme | async), 'titanium': isTitanium || (appState.showPreciousTheme | async) === false}"></menu-header>
}
@if (isReady) {
  <main [ngClass]="{'precious': !isTitanium && (appState.showPreciousTheme | async), 'titanium': isTitanium || (appState.showPreciousTheme | async) === false}">
    @if (showAnimation) {
      <div id="page-wrapper" [@routerTransition]="routerState(page)" class="inline-scroll">
        <router-outlet #page="outlet"></router-outlet>
      </div>
    }
    @if (!showAnimation) {
      <div id="page-wrapper" class="inline-scroll">
        <router-outlet></router-outlet>
      </div>
    }
  </main>
}
<alert></alert>
<footer></footer>
@if(showKEYELoginInfo){

}
@if (showKEYELoginInfo) {
  <div class="login-info" [ngClass]="{'hide': hideLoginInfo}">
    <div class="content">
      <h2 [innerHTML]="'LOGIN.KEYE.HEADER' | translate"></h2>
      <div [innerHTML]="'LOGIN.KEYE.DESCRIPTION' | translate"></div>
      <div [innerHTML]="'LOGIN.KEYE.GOTOMYKERING' | translate" class="btn-out" (click)="goToMyKeringEyeWear()"></div>
    </div>
    <div class="footer">
      <div>Copyright <span class="lindberg">LINDBERG</span> {{ currentYear }}. All rights reserved</div>
    </div>
    <div class="employee-login" >
      <div [innerHTML]="'LOGIN.KEYE.EMPLOYEELOGIN' | translate" (click)="hideLoginInfoOverlay()"></div>
    </div>
  </div>
}
@if (appState.showChineseLicenseId) {
  <a href="https://beian.miit.gov.cn/" target="_blank" class="chineseLicense">沪ICP备18032619号-1</a>
}